import type { SVGProps } from 'react';
const DawnFlagVN = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect width={22} height={16} fill="#fff" rx={2} />
    <mask
      id="dawn-flag-VN_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect width={22} height={16} fill="#fff" rx={2} />
    </mask>
    <g mask="url(#dawn-flag-VN_svg__a)">
      <path fill="#EA403F" d="M0 0h22v16H0z" />
      <path
        fill="#FFFE4E"
        fillRule="evenodd"
        d="m11 9.872-2.77 2.011 1.022-3.305-2.735-2.061 3.403-.032L11 3.2l1.081 3.285 3.403.032-2.735 2.061 1.022 3.305z"
        clipRule="evenodd"
      />
    </g>
  </svg>
);
export default DawnFlagVN;
